module.exports = __webpack_public_path__ + "static/media/Copperplate Gothic Light Regular.26687a81.svg";